export default __webpack_public_path__ + "static/media/192.a7c49218.png";